import HandleAxiosError from "utils/helpers/HandleAxiosError";
import ApiClient from "utils/plugins/ApiClient";
export const getUserprofile = (payload) => {
  return ApiClient.get("/user/profile", payload)
    .then((response) => {
      return response.data.response.data;
    })
    .catch((error) => {
      throw HandleAxiosError(error);
    });
};
